import { CliError, CliErrorCode } from '@wix/cli-error';
import type {
  FullDocument,
  DocumentUpdate,
  ConvertToOnlineLayoutCB,
} from '@wix/anyide-intellisense-adapter';
import { createIntellisenseAdapter as createIntellisenseAdapterOriginal } from '@wix/anyide-intellisense-adapter';

export async function createIntellisenseAdapter(
  projectFolder: string,
  convertToOnlineLayout: ConvertToOnlineLayoutCB
) {
  const adapter = await createIntellisenseAdapterOriginal(
    convertToOnlineLayout,
    projectFolder
  ).catch((error: unknown) => {
    throw new CliError({
      code: CliErrorCode.FailedToCreateIntellisenseAdapter(),
      cause: error,
    });
  });

  return {
    initTypes: async (document: FullDocument) => {
      try {
        await adapter.initTypes(document);
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToInitIntellisenseAdapterTypes(),
          cause: error,
        });
      }
    },
    updateTypes: async (document: DocumentUpdate) => {
      try {
        await adapter.updateTypes(document);
      } catch (error) {
        throw new CliError({
          code: CliErrorCode.FailedToUpdateIntellisenseAdapterTypes(),
          cause: error,
        });
      }
    },
  };
}
